<script>
  import { onMount } from "svelte"
  import packageInfo from "../../package.json"
  const parser = new DOMParser()
  let feed = []
  onMount(async () => {
    const rssReq = await fetch("https://oo1eqf0dv7.execute-api.eu-west-1.amazonaws.com/dev/rss-router?url=https://css-tricks.com/feed/", {
      mode: "cors"
    })
    const xmlDoc = parser.parseFromString(await rssReq.text(), "text/xml")
    const items = Array.from(xmlDoc.querySelectorAll("item"))
    feed = items.map((item) => {
      window.boo = item
      return {
        title: item.querySelector("title").textContent,
        author: item.querySelector("dc,creator").textContent,
        pubDate: item.querySelector("pubDate").textContent,
        url: item.querySelector("link").textContent
      }
    })
  })
</script>

<style>
  #welcome-section {
    height: 100%;
    overflow: auto;
    padding: 15px;
  }
  .articles {
    overflow: auto;
  }

  .articles a {
    text-decoration: none;
    color: #9aa2b1;
    margin: 20px 0;
    margin-left: 10px;
    display: block;
  }
  h4 {
    font-size: 18px;
    font-weight: 600;
    transition: 0.3s ease;
  }
  .articles a:hover {
    color: orange;
  }
  .intro {
    text-align: center;
  }
  .intro img {
    width: 350px;
    margin: 120px 0 20px;
    text-align: center;
  }
  p,
  li {
    color: #9aa2b1;
    font-size: 16px;
    line-height: 1.45;
    margin-bottom: 15px;
  }

  a {
    color: orange;
  }
  .title {
    color: #d7dae0;
    font-size: 18px;
  }
  .headline {
    color: #d7dae0;
    font-family: Helvetica, sans-serif;
    margin-bottom: 20px;
  }
  h2 {
    font-size: 30px;
  }
  main {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-top: 40px;
  }
</style>

<div id="welcome-section">
  <div class="intro">
    <img src="https://cdn.jsdelivr.net/npm/ixcanul@latest/dist/images/ixcanul.png" alt="Ixcanul Logo" />
    <p>version {packageInfo.version}</p>
    <p class="title">A code editor for the Volcanic Platform</p>
  </div>
  <main>
    <div>
      <h2 class="headline">Changelog</h2>
      <ol>
        <li>Feature: Support create Tephra Snippet for prebuilt library <a target="_blank" rel="no-follow" href="https://dev.azure.com/access-devops/Access%20Recruitment%20Websites/_workitems/edit/403819">ADO</a></li>
        <li>Chore: Support Node14</li>
        <li>Chore: upgrade build system to Webpack 5 and drop support for old browsers</li>
        <li>Fix: Search for non regular expressions breaks Search Results on theme<a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-77">Jira</a></li>
        <li>Fix: Search returning results for wrong files <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-76">Jira</a></li>
        <li>Fix: Search theme breaks after a search that didn't yield any results <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-74">Jira</a></li>
        <li>Fix: [Alert] no alert if there is no results <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-75">Jira</a></li>
        <li>Fix: Able to open same image file in multiple tabs and all image showing in one tab. <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-73">Jira</a></li>
        <li>Feature - Reworked the global search panel and added support to case sensitive search</li>
        <li>Feature: Enable source code upload to website folders</li>
        <li>Fix: Ixcanul's Replace All is not working <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-20">Jira</a></li>
        <li>Fix - File opens when it is renamed <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-57">Jira</a></li>
        <li>
          Fix - Adding new file should not have highlighted by default the file extension
          <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-62">Jira</a>
        </li>
        <li>
          Fix - Highlight tephra-file tabs to distinguish them from theme files
          <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-66">Jira</a>
        </li>
        <li>Fix - Closing an unfocused tab will focus it <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-71">Jira</a></li>
        <li>
          Fix - Tab of file that was deleted will remain open. Ixcanul crashes if tab is selected.
          <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-60">Jira</a>
        </li>
        <li>
          Fix - Adding a file to snippets/shared will prompt to add a file 'from the family ("snippets/shared/_footer.liquid")'
          <a target="_blank" rel="no-follow" href="https://volcanicuk.atlassian.net/browse/IX-63">Jira</a>
        </li>
        <li>
          Feature - Refactor the tephra snippets search menu ( navigate to it by right-click on the "tephra" folder
          {'->'}
          add snippet ) - (Tiago Ferreira & Nedo)
          <ol>
            <li>Show the snippet path (family and name)</li>
            <li>Now the search is fuzzy and targeted at the snippet "path" (family name + title) and it will still find results even with some typos</li>
            <li>Show a green tag box next to name to highlight site builder specific snippets</li>
            <li>Few more UX improvements on that panel</li>
          </ol>
        </li>
        <li>Fix - UX imporvements on the global code search panel (Tiago Ferreira)</li>
        <li>
          Feature - Keep quoations on "var" liquid tag default value when a special character is detected (i.e. a hex color as a default value #f00) (Tiago
          Ferreira)
        </li>
        <li>Feature - custom icon for snippets/builder.config.json (Tiago Ferreira)</li>
        <li>Feature - When you create a new file it will open automatically (Tiago Ferreira)</li>
        <li>Feature - Global Search results now show a clear distinction in the search results bar (Tiago Ferreira)</li>
        <li>Fix - dismiss the "are you sure you want to exit" modal when you click on any of action buttons (Tiago Ferreira)</li>
        <li>Fix - When you create new folders repeatedly, the new folder reference will become "untitled_folder_n"</li>
        <li>Fix - tephra snippet properties</li>
        <li>Fix - use ctrl+shift+f to toggle the global search menu</li>
        <li>Fix - Tephra tags manager is now working !</li>
        <li>Fix unresponsive tabs when you delete an open file (Tiago Ferreira)</li>
        <li>Fix File history not opening</li>
        <li>
          Integrated
          <a href="https://docs.emmet.io/cheat-sheet/" target="_blank">Emmet</a>
          into ixcanul. Go to any css file -> type "bgc" or "p20-10-0" then press the `tab` key on your keyboard :)
        </li>
        <li>A new welcome tab ( work in progress ), feedback is welcome !</li>
        <li>New autocomplete panel with improved completions to activate (during editing) press ctrl + space</li>
        <li>Ignore code formatting by adding the line `/* ixcanul-ignore-formatting */` to the top of your document (not reccomended)</li>
        <li>Syntax highlighting for some liquid tags that are specific to our volcanic platform (like tephra, var, t, v, etc)</li>
        <li>Support legacy tephra snippets ( Thanks Octa ^_^ )</li>
        <li>Fixed the famous unresponsive tabs bug ... if it still occures please let us know on Jira</li>
        <li>When you have more than 5 recent tabs Ixcnaul will present a prompt asking you if you'd want load all of them</li>
        <li>Recent tabs are no longer shared between themes on the same stack</li>
        <li>Stable theme ovewrite</li>
        <li>Refactored many parts of ixcanul and changed the build tool to webpack to allow for easier development cycles</li>
        <li>Integrated the Svelte framework into the codebase ( this welcome tab is just svelte :p )</li>
      </ol>
      <p>More features coming soon / pending release</p>
    </div>
    <div class="articles">
      <h2 class="headline">Latest front end articles:</h2>
      {#each feed as item}
        <a href={item.url} target="_blank">
          <h4>{item.title}</h4>
        </a>
      {/each}
      <p>
        Right now this list is pulling from CSS tricks only, we can make it pull from pretty much anywhere that has an RSS feed. Suggestions are encouraged !
      </p>
    </div>
  </main>
</div>
